"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _amazon = require("./amazon");

Object.keys(_amazon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _amazon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _amazon[key];
    }
  });
});

var _bandcamp = require("./bandcamp");

Object.keys(_bandcamp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _bandcamp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _bandcamp[key];
    }
  });
});

var _behance = require("./behance");

Object.keys(_behance).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _behance[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _behance[key];
    }
  });
});

var _chain = require("./chain");

Object.keys(_chain).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _chain[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _chain[key];
    }
  });
});

var _codepen = require("./codepen");

Object.keys(_codepen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _codepen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _codepen[key];
    }
  });
});

var _deviantart = require("./deviantart");

Object.keys(_deviantart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _deviantart[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _deviantart[key];
    }
  });
});

var _dribbble = require("./dribbble");

Object.keys(_dribbble).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dribbble[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dribbble[key];
    }
  });
});

var _dropbox = require("./dropbox");

Object.keys(_dropbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dropbox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dropbox[key];
    }
  });
});

var _etsy = require("./etsy");

Object.keys(_etsy).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _etsy[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _etsy[key];
    }
  });
});

var _facebook = require("./facebook");

Object.keys(_facebook).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _facebook[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _facebook[key];
    }
  });
});

var _feed = require("./feed");

Object.keys(_feed).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _feed[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _feed[key];
    }
  });
});

var _fivehundredpx = require("./fivehundredpx");

Object.keys(_fivehundredpx).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fivehundredpx[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fivehundredpx[key];
    }
  });
});

var _flickr = require("./flickr");

Object.keys(_flickr).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _flickr[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _flickr[key];
    }
  });
});

var _foursquare = require("./foursquare");

Object.keys(_foursquare).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _foursquare[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _foursquare[key];
    }
  });
});

var _goodreads = require("./goodreads");

Object.keys(_goodreads).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _goodreads[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _goodreads[key];
    }
  });
});

var _google = require("./google");

Object.keys(_google).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _google[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _google[key];
    }
  });
});

var _github = require("./github");

Object.keys(_github).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _github[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _github[key];
    }
  });
});

var _instagram = require("./instagram");

Object.keys(_instagram).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _instagram[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _instagram[key];
    }
  });
});

var _lastfm = require("./lastfm");

Object.keys(_lastfm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _lastfm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _lastfm[key];
    }
  });
});

var _linkedin = require("./linkedin");

Object.keys(_linkedin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _linkedin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _linkedin[key];
    }
  });
});

var _mail = require("./mail");

Object.keys(_mail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mail[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mail[key];
    }
  });
});

var _mastodon = require("./mastodon");

Object.keys(_mastodon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mastodon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mastodon[key];
    }
  });
});

var _meetup = require("./meetup");

Object.keys(_meetup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _meetup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _meetup[key];
    }
  });
});

var _medium = require("./medium");

Object.keys(_medium).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _medium[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _medium[key];
    }
  });
});

var _patreon = require("./patreon");

Object.keys(_patreon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _patreon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _patreon[key];
    }
  });
});

var _pinterest = require("./pinterest");

Object.keys(_pinterest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pinterest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pinterest[key];
    }
  });
});

var _pocket = require("./pocket");

Object.keys(_pocket).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pocket[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pocket[key];
    }
  });
});

var _reddit = require("./reddit");

Object.keys(_reddit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _reddit[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _reddit[key];
    }
  });
});

var _skype = require("./skype");

Object.keys(_skype).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _skype[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _skype[key];
    }
  });
});

var _snapchat = require("./snapchat");

Object.keys(_snapchat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _snapchat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _snapchat[key];
    }
  });
});

var _soundcloud = require("./soundcloud");

Object.keys(_soundcloud).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _soundcloud[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _soundcloud[key];
    }
  });
});

var _spotify = require("./spotify");

Object.keys(_spotify).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _spotify[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _spotify[key];
    }
  });
});

var _telegram = require("./telegram");

Object.keys(_telegram).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _telegram[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _telegram[key];
    }
  });
});

var _tiktok = require("./tiktok");

Object.keys(_tiktok).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tiktok[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tiktok[key];
    }
  });
});

var _tumblr = require("./tumblr");

Object.keys(_tumblr).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tumblr[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tumblr[key];
    }
  });
});

var _twitch = require("./twitch");

Object.keys(_twitch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _twitch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _twitch[key];
    }
  });
});

var _twitter = require("./twitter");

Object.keys(_twitter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _twitter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _twitter[key];
    }
  });
});

var _vimeo = require("./vimeo");

Object.keys(_vimeo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _vimeo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _vimeo[key];
    }
  });
});

var _vk = require("./vk");

Object.keys(_vk).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _vk[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _vk[key];
    }
  });
});

var _wordpress = require("./wordpress");

Object.keys(_wordpress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _wordpress[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _wordpress[key];
    }
  });
});

var _yelp = require("./yelp");

Object.keys(_yelp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _yelp[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _yelp[key];
    }
  });
});

var _youtube = require("./youtube");

Object.keys(_youtube).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _youtube[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _youtube[key];
    }
  });
});
//# sourceMappingURL=index.js.map